import { handleActions } from 'redux-actions';
import { initState } from '../../../redux/models';
import * as actionType from './actionType';

export default handleActions(
  {
    //更新信息
    [actionType.ENTRYANDCORE_UPDATE]: (state, { data }) => {
      const newState = { ...state, ...data };
      return newState;
    },
    [actionType.ENTRYANDCORE_FILE]: state => {
      const newState = {
        ...state,
        modalTuttonLoading: false,
        tableLoading: false,
        tabPopleLoading: false,
      };
      return newState;
    },
  },
  initState,
);
